import { dew as _getAddressDew } from "../../utils/address/getAddress.js";
import { dew as _keccakDew } from "../../utils/hash/keccak256.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.publicKeyToAddress = void 0;
  const getAddress_js_1 = _getAddressDew();
  const keccak256_js_1 = _keccakDew();
  function publicKeyToAddress(publicKey) {
    const address = (0, keccak256_js_1.keccak256)(`0x${publicKey.substring(4)}`).substring(26);
    return (0, getAddress_js_1.checksumAddress)(`0x${address}`);
  }
  exports.publicKeyToAddress = publicKeyToAddress;
  //# sourceMappingURL=publicKeyToAddress.js.map
  return exports;
}